var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 312,
    width: 96,
    height: 96
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-592 -312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651 333.867 651 360 640 360 640 329 614 329 614 352 603 352 603 391 677 391 677 337.117ZM616 331 638 331 638 360 629 360 629 352 616 352ZM627 389 618 389 618 383 614 383 614 389 605 389 605 354 627 354 627 389ZM651 389 642 389 642 383 638 383 638 389 629 389 629 362 651 362ZM675 389 666 389 666 383 662 383 662 389 653 389 653 336.133 675 338.883Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 375.018 638 375.018 638 379.019 634 379.019Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 375.018 646 375.018 646 379.019 642 379.019Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 367 638 367 638 371.001 634 371.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 367 646 367 646 371.001 642 371.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621 344.018 625 344.018 625 348.019 621 348.019Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 344.018 633 344.018 633 348.019 629 348.019Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621 336 625 336 625 340.001 621 340.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 336 633 336 633 340.001 629 340.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.001 375.018 614.001 375.018 614.001 379.019 610.001 379.019Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.001 375.018 622.001 375.018 622.001 379.019 618.001 379.019Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.001 367 614.001 367 614.001 371.001 610.001 371.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.001 367 622.001 367 622.001 371.001 618.001 371.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.001 359 614.001 359 614.001 363.001 610.001 363.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.001 359 622.001 359 622.001 363.001 618.001 363.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658 375.018 662 375.018 662 379.019 658 379.019Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666 375.018 670 375.018 670 379.019 666 379.019Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658 367 662 367 662 371.001 658 371.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666 367 670 367 670 371.001 666 371.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658 359 662 359 662 363.001 658 363.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666 359 670 359 670 363.001 666 363.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658 351.018 662 351.018 662 355.019 658 355.019Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666 351.018 670 351.018 670 355.019 666 355.019Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658 343 662 343 662 347.001 658 347.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666 343 670 343 670 347.001 666 347.001Z",
    fill: "#000000",
    fillRule: "nonzero",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.d4f69d545725397d15855b290c50068e.svg";
export { ForwardRef as ReactComponent };